import { Record } from 'immutable';

const struct = {
  id:                     undefined,
  name:                   undefined,
  locale:                 undefined,
  logo:                   undefined,
  description:            undefined,
  jobBanner:              undefined,
  dataPolicyUrl:          undefined,
  termsAndConditionsUrl:  undefined,
  parameters:             {},
  smsEnabled:             false,
  whatsappEnabled:        false,
  messengerEnabled:       false,
  messengerUrl:           undefined,
  listingsBanner:         undefined,
  erpListingBanner:       undefined,
  erpEnabled:             undefined,
  landingPagePopUpScreen: undefined,
  email:                  undefined,
  whatsappPhone:          undefined,
};

export default class Company extends Record(struct, 'Company') {
  privacyPolicyText() {
    if (!this.dataPolicyUrl) {
      return t('eos.landing_page.text.privacy_policy_talkpush');
    }

    return t('eos.landing_page.text.privacy_policy', { company: this.name, policy_url: this.dataPolicyUrl });
  }

  popUpPrivacyPolicyText() {
    if (this.smsEnabled) {
      return t('eos.landing_page.text.pop_up_privacy_policy_with_sms', { company: this.name, policy_url: this.dataPolicyUrl });
    }

    return t('eos.landing_page.text.pop_up_privacy_policy', { company: this.name, policy_url: this.dataPolicyUrl });
  }

  smsPrivacyPolicyText() {
    if (this.dataPolicyUrl && this.termsAndConditionsUrl) {
      return t('eos.landing_page.text.sms_privacy_policy_company_with_terms', { company: this.name, policy_url: this.dataPolicyUrl, terms_and_conditions_url: this.termsAndConditionsUrl });
    }

    if (this.dataPolicyUrl) {
      return t('eos.landing_page.text.sms_privacy_policy_company_only', { company: this.name, policy_url: this.dataPolicyUrl });
    }

    return t('eos.landing_page.text.sms_privacy_policy_default', { company: this.name });
  }

  /* Applicable only for LP's One question per page config */
  allowLandingPageResponseResubmit() {
    return [null, undefined, true].includes(this.parameters.landingPageResponseResubmit);
  }

  inboundEmail(campaignId) {
    if (this.email) {
      return this.email;
    }

    return `${this.id}-${campaignId}@inbound.talkpush.com`;
  }

  erpEnabled() {
    return (
      this.parameters.employeeReferralProgram?.enabled === '1'
      || this.parameters.employeeReferralProgram?.enabled === true
    ) || false;
  }

  erpCustomFieldsEnabled() {
    return this.parameters.employeeReferralProgram?.customFieldsEnabled === true;
  }

  erpOnScreenLinkEnabled() {
    return this.parameters.employeeReferralProgram?.onScreenLinkEnabled === true;
  }

  erpEmailRequired() {
    return this.parameters.employeeReferralProgram?.options?.emailRequired === true;
  }

  erpEmployeeIdRequired() {
    return this.parameters.employeeReferralProgram?.options?.employeeIdRequired === true;
  }

  erpEnableSendLinkToEmail() {
    return this.parameters.employeeReferralProgram?.options?.sendLinkToEmail === true;
  }

  vonqOpnEnabled() {
    return this.parameters.vonqIntegrationOpn === true;
  }

  vonqPaidPostingEnabled() {
    return this.parameters.vonqIntegrationPaidPosting === true;
  }
}
